import { initialState } from './message.state';
import {
  ActionTypes,
  EnumActionsTypes,
  MessageState,
} from './message.redux.types';

export const MessageReducer = (
  state = initialState,
  action: ActionTypes,
): MessageState => {
  switch (action.type) {
    case EnumActionsTypes.SHOW_MESSAGE:
      return {
        ...state,
        ...action.payload,
        showMessage: true,
      };
    case EnumActionsTypes.HIDE_MESSAGE:
      return {
        ...state,
        showMessage: false,
      };
    default:
      return state;
  }
};
